export default date => (date
  ? `${date.substr(6, 2)}/${date.substr(4, 2)}/${date.substr(2, 2)}`
  : undefined);
